export default "__VITE_ASSET__Co7002my__"